import { render, staticRenderFns } from "./AddProductHeader.vue?vue&type=template&id=57dd69a8"
import script from "./AddProductHeader.vue?vue&type=script&lang=js"
export * from "./AddProductHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports